/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ agent: NonNullable<unknown> }} Agent_Builder_Model_PinnedInputs */



/**
* | output |
* | --- |
* | "Model set by {agent}" |
*
* @param {Agent_Builder_Model_PinnedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_model_pinned = /** @type {((inputs: Agent_Builder_Model_PinnedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Model_PinnedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Modell durch ${i?.agent} festgelegt`)
	return /** @type {LocalizedString} */ (`Model set by ${i?.agent}`)
});